import {UploadedFile} from '@interfaces/file.interface';

export namespace LaboratoryNamespace {

    /**
     * Типы ответственных лиц
     */
    export enum ResponsibleStaffType {
        /**
         * Функционирование системы менеджмента качества
         */
        quality = 'respstaff_quality',
        /**
         * Метрологическое обеспечение и техническое состояние оборудования
         */
        support = 'respstaff_support',
        /**
         * Ведение архива
         */
        archive = 'respstaff_archive',
        /**
         * Ведение фонда нормативной и технической документации
         */
        ntd = 'respstaff_ntd',
        /**
         * Радиационная безопасность
         */
        rk = 'respstaff_rk',
        /**
         * Хранение и выдача ИИИ
         */
        iii = 'respstaff_iii',
    }

    export interface ResponsibleStaffFieldType {
        /**
         * Тип ответственного
         */
        type_staff: ResponsibleStaffType;
        /**
         * Обязательно ли для заполнения
         */
        required: boolean;
        /**
         * Наименования поля
         */
        title: string;
    }

    /**
     * Информация по ответственному
     */
    export interface ResponsibleStaffValue {
        /**
         * Id сущности
         */
        id: number;
        laboratory_id: number;
        type_staff: ResponsibleStaffType;

        /**
         * Поля данных о специалисте
         */
        full_name: string;
        specialist_id: number;
        job_title: string;
        photo: UploadedFile;
    }
}
